let host = {
  apiUrl: '',
  getToken: () => null
};
export const configure = value => {
  host = value;
};
export async function request(path, body, method) {
  const token = host.getToken();
  const response = await fetch(`${host.apiUrl.replace(/\/$/, '')}/api/multibagger-selection${path}`, {
    method: method || (body === undefined ? 'GET' : 'POST'),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? {
        Authorization: `Bearer ${token}`
      } : {})
    },
    ...(body === undefined ? {} : {
      body: JSON.stringify(body)
    })
  });
  const data = await response.json();
  if (!response.ok) {
    const message = String(data.error || 'Request failed')
      .replace(/&#x20;|&#32;/gi, ' ')
      .replace(/&quot;/gi, '"')
      .replace(/&#x27;|&#39;/gi, "'")
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .trim();
    throw new Error(message);
  }
  return data.data;
}
